export default __webpack_public_path__ + "static/media/logo.151f08ec.png";